import { mobileBreakpoint } from "hardcodes"

export const isPhone = () => {
  const userAgent = navigator.userAgent

  const isAndroid = /android/i.test(userAgent)
  const isIOS = /iPhone|iPad|iPod/i.test(userAgent)

  return (isAndroid || isIOS) && window.innerWidth <= mobileBreakpoint
}
